import React from 'react';
import { Link } from 'react-router-dom';
import './ListPost.scss';

function ListPost(props) {
  const { text, image, link, altText } = props;
  return (
    <div className="list-post">
      <div className="list-post-img">
        <img src={image} alt={altText} />
      </div>
      <div className="list-post-text">
      <Link to={{ pathname: link }} target="_blank">{text}</Link>
      </div>
    </div>
  );
}

export default ListPost;
